const {
  GET_RESTOCK_PRODUCTS_REQUEST,
  GET_RESTOCK_PRODUCTS_SUCCESS,
  RESTOCK_PRODUCTS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_RESTOCK_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RESTOCK_PRODUCTS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case RESTOCK_PRODUCTS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
